import { render, staticRenderFns } from "./VTabItem.vue?vue&type=template&id=8f46197a&"
import script from "./VTabItem.vue?vue&type=script&lang=js&"
export * from "./VTabItem.vue?vue&type=script&lang=js&"
import style0 from "./VTabItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports